import { SummaryData } from '../../interfaces/SummaryData';

export const summaryTableColumn = [
	{
		title: 'Country',
		id: 1,
		component: ({ content }: { content: SummaryData }) => content.country,
		width: 'greedy',
	},
	{
		title: 'State',
		id: 2,
		component: ({ content }: { content: SummaryData }) => content.state,
		width: 'greedy',
	},
	{
		title: 'Tax Type',
		id: 3,
		component: ({ content }: { content: SummaryData }) => content.taxType,
		width: 'greedy',
	},
	{
		title: 'Tax Amount',
		id: 4,
		component: ({ content }: { content: SummaryData }) => `$ ${content.taxAmount}`,
		width: 'greedy',
		dataKey: 'currency',
	},
	{
		title: 'Exempt Amount',
		id: 5,
		component: ({ content }: { content: SummaryData }) => `$ ${content.exemptAmount}`,
		width: 'greedy',
		dataKey: 'currency',
	},
];
